import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { matchPath, Navigate } from "react-router-dom";
import { orderFulfillmentAnalyticsRoutes } from "../../../analytics/order-fulfillment/route";
import { outboundLabelRoutes, wmsRoutes } from "../../../order/route";
import { carrierClaimsRoutes } from "../../../return/route";
import { warehouseRoutes } from "./warehouse-routes";

const SHIPPING_ROUTE_BASE = "/stores/:storeId/shipping";

const HIDE_PADDING_ROUTES: string[] = [
  "/batch-history",
  "/bulk-fulfillments",
  "/carrier-claims",
  "/eod-manifest",
  "/outbound-labels/*",
  "/outbound-labels/bad-warehouse-bins",
  "/wms/*",
  "/warehouse",
  "/warehouse/*",
  "/analytics/order-fulfillment",
];

function hidePadding(url: string): boolean {
  if (matchPath(`${SHIPPING_ROUTE_BASE}/outbound-labels/about`, url)) {
    return false;
  }
  return HIDE_PADDING_ROUTES.some(
    (route) => !!matchPath(`${SHIPPING_ROUTE_BASE}${route}`, url),
  );
}

const FULLSCREEN_ROUTES: string[] = [
  "/outbound-labels/packing-slips/:packingSlipId",
  "/outbound-labels/personalized-slips/:personalizedSlipId",
  "/outbound-labels/pick-sessions",
  "/outbound-labels/pick-sessions/:pickSessionId",
  "/outbound-labels/pick-sessions/:pickSessionId/tote-scanning",
  "/outbound-labels/pick-sessions/:pickSessionId/route",
  "/outbound-labels/create-pick-session",
  "/wms/work-orders/detail/:workOrderId",
  "/warehouse",
  "/warehouse/*",
];

const HIDE_HEADER_ROUTES: string[] = [...FULLSCREEN_ROUTES];
function hideHeader(url: string): boolean {
  return HIDE_HEADER_ROUTES.some(
    (route) => !!matchPath(`${SHIPPING_ROUTE_BASE}${route}`, url),
  );
}

const HIDE_NAV_ROUTES: string[] = [...FULLSCREEN_ROUTES];

function hideNav(url: string): boolean {
  return HIDE_NAV_ROUTES.some(
    (route) => !!matchPath(`${SHIPPING_ROUTE_BASE}${route}`, url),
  );
}

export const shippingRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Shipping", breadcrumbNavigate: false },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={hideHeader}
            hideNavbar={hideNav}
            hidePadding={hidePadding}
          />
        ),
      };
    },
    children: [
      { index: true, element: <Navigate replace to="outbound-labels" /> },
      {
        path: "classify-products",
        handle: { breadcrumb: "Classify products" },
        async lazy() {
          const { ClassifyProductsPage } = await import(
            "../../../order/classify-products-page"
          );
          return { element: <ClassifyProductsPage /> };
        },
      },
      {
        path: "order-edits",
        handle: {
          breadcrumb: "Order editing",
          permission: OrderManagementPermissions.VIEW_ORDER,
        },
        async lazy() {
          const { OrderEditsPage } = await import(
            "../../../order-edits/order-edits-page"
          );
          return { element: <OrderEditsPage /> };
        },
      },
      {
        path: "analytics/order-fulfillment",
        handle: { breadcrumb: "Analytics", breadcrumbNavigate: false },
        children: orderFulfillmentAnalyticsRoutes,
      },
      { path: "carrier-claims", children: carrierClaimsRoutes },
      { path: "outbound-labels", children: outboundLabelRoutes },
      { path: "wms", children: wmsRoutes },
      { path: "warehouse", children: warehouseRoutes },
    ],
  },
];
